import excessStockIcon from '../assets/image/excess-stocks-icon.svg';
import lowStockIcon from '../assets/image/low-stock-icon.svg';
import nearExpiryIcon from '../assets/image/near-expiry-batch-icon.svg';
import expiredIcon from '../assets/image/expired-batch-icon.svg';
import outOfStockIcon from '../assets/image/out-stock.svg';

export const constant = {
	bigNumber: 1e5,
	drugLicenseRegex: /^([^\d]*\d){12}[^\d]*$/,
	panCardRegex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
	emailRegex: /\S+@\S+\.\S+/,
	gstRegex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
};

export const CREDIT_NOTE_TYPE = {
	1: 'Damaged/Returned Goods',
	2: 'Excess Payment',
	3: 'Advance Payment',
};

export const reportNamefilter = (type) => {
	switch (type) {
		case 'Sale By Customers':
			return 'sales_by_customer';
		case 'Sale By Products':
			return 'sales_by_product';
		default:
			return type;
	}
};

export const productStatusList = [
	'Inactive Products',
	'Low Stocks Products',
	'Out Of Stocks',
	'Excess Stocks',
	'Near Expiry Stocks',
	'Expired Stocks',
	'Sales',
	'Purchase',
];

export const ACCOUNTS_STATUS = [
	{ key: 1, value: 'Active' },
	{ key: 0, value: 'Inactive' },
];
export const ACCOUNTS_STATUS_LIST = [
	{ key: '', label: 'All Accounts' },
	{ key: 'active', label: 'Active' },
	{ key: 'inactive', label: 'Inactive' },
	{ key: 'asset', label: 'Asset' },
	{ key: 'liability', label: 'Liability' },
	{ key: 'equity', label: 'Equity' },
	{ key: 'income', label: 'Income' },
	{ key: 'expense', label: 'Expense' },
];
export const PRODUCT_GROUP_BY = [
	{ key: 'customer_name', label: 'Customer Name' },
	{ key: 'place_of_supply', label: 'Place of Supply' },
];

export const PROFIT_PRODUCT_GROUP_BY = [
	{ key: 'group_name', label: 'Group Name' },
	{ key: 'category', label: 'Category' },
];

export const DATE_RANGE = [
	{
		label: 'Today',
		key: 'today',
	},
	{
		label: 'This Week',
		key: 'this_week',
	},
	{
		label: 'This Month',
		key: 'this_month',
	},
	{
		label: 'This Quarter',
		key: 'this_quarter',
	},
	{
		label: 'This Year',
		key: 'this_year',
	},
	{
		label: 'Yesterday',
		key: 'yesterday',
	},
	{
		label: 'Previous Week',
		key: 'previous_week',
	},
	{
		label: 'Previous Month',
		key: 'last_month',
	},
	{
		label: 'Previous Quarter',
		key: 'last_quarter',
	},
	{
		label: 'Previous Year',
		key: 'last_year',
	},
	{
		label: 'Custom',
		key: 'custom',
	},
];

export const TRANSACTION_TYPE = [
	{
		key: 'invoices',
		label: 'Invoices',
	},
	{
		key: 'credit_notes',
		label: 'Credit Notes',
	},
];

export const checkProductStatus = (tag) => {
	switch (tag) {
		case 'Low Stocks Products':
			return 'low_stock';
		case 'Out Of Stocks':
			return 'out_of_stock';
		case 'Expired Stocks':
			return 'expired';
		case 'Near Expiry Stocks':
			return 'near_expiry';
		case 'Excess Stocks':
			return 'excess_stock';
		case 'Inactive Products':
			return 'inactive';
		case 'Sales':
			return 'sales_product';
		case 'Purchase':
			return 'purchase_product';
		default:
			return tag;
	}
};
export const formatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return 'Low Stock';
		case 'out_of_stock':
			return 'Product Out of Stock';
		case 'expired':
			return 'Batch Expired';
		case 'near_expiry':
			return 'Batch Near Expiring';
		case 'excess_stock':
			return 'Excess Stock';
		case 'inactive':
			return 'Inactive';
		case 'sales_product':
			return 'Sales Product';
		case 'purchase_product':
			return 'Purchase Product';
		default:
			return tag;
	}
};
export const colorFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return '#E7E3B4';
		case 'out_of_stock':
			return '#FFEED5';
		case 'expired':
			return '#FCCFCF';
		case 'near_expiry':
			return '#FFEDED';
		case 'excess_stock':
			return '#BEE8E2';
		case 'sales_product':
			return '#B3E0FF';
		case 'purchase_product':
			return '#F9E8FC';
		default:
			return '#718096';
	}
};
export const batchColorFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return '#FEC53D';
		case 'out_of_stock':
			return '#FF0000';
		case 'expired':
			return '#A0616A';
		case 'near_expiry':
			return '#EB996E';
		case 'excess_stock':
			return '#16EACC';
		default:
			return '#718096';
	}
};
export const iconFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return lowStockIcon;
		case 'expired':
			return expiredIcon;
		case 'near_expiry':
			return nearExpiryIcon;
		case 'excess_stock':
			return excessStockIcon;
		case 'out_of_stock':
			return outOfStockIcon;
		default:
			return null;
	}
};

export const formatDateDDMMYYYY = (date) => {
	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year = date.getFullYear();

	return `${day}/${month}/${year}`;
};

export const formatDateSymbol = (dateStr) => {
	const [year, month, day] = dateStr.split('-');
	return `${day}/${month}/${year}`;
};

export const formatKey = (label) => {
	return label.toLowerCase().replace(/\s+/g, '_');
};

export const getDateRange = (DateRangeType) => {
	const type = DateRangeType;
	const now = new Date();
	let from = null;
	let to = new Date();

	const formatStart = (date) => new Date(date.setHours(0, 0, 0, 0));

	const formatEnd = (date) => new Date(date.setHours(23, 59, 59, 999));

	switch (type) {
		// ✅ TODAY
		case 'today': {
			from = formatStart(new Date());
			to = new Date(); // current time
			break;
		}

		// ✅ YESTERDAY
		case 'yesterday': {
			const y = new Date();
			y.setDate(y.getDate() - 1);

			from = formatStart(new Date(y));
			to = formatEnd(new Date(y));
			break;
		}

		// ✅ THIS WEEK (Mon → Today, Monday fix)
		case 'this_week': {
			const today = new Date();
			const day = today.getDay(); // 0 (Sun) - 6 (Sat)

			// Get Monday of current week
			const diff = day === 0 ? -6 : 1 - day;

			const monday = new Date(today);
			monday.setDate(today.getDate() + diff);

			// From = Monday
			from = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate());

			// To = Today (always)
			to = new Date(today.getFullYear(), today.getMonth(), today.getDate());

			break;
		}

		// ✅ PREVIOUS WEEK
		case 'previous_week': {
			const today = new Date();
			const day = today.getDay();
			const diff = day === 0 ? -6 : 1 - day;

			const currentMonday = new Date(today);
			currentMonday.setDate(today.getDate() + diff);

			const prevMonday = new Date(currentMonday);
			prevMonday.setDate(currentMonday.getDate() - 7);

			const prevSunday = new Date(prevMonday);
			prevSunday.setDate(prevMonday.getDate() + 6);

			from = formatStart(prevMonday);
			to = formatEnd(prevSunday);
			break;
		}

		// ✅ THIS MONTH
		case 'this_month':
			from = formatStart(new Date(now.getFullYear(), now.getMonth(), 1));
			to = new Date();
			break;

		// ✅ PREVIOUS MONTH
		case 'last_month':
			from = formatStart(new Date(now.getFullYear(), now.getMonth() - 1, 1));
			to = formatEnd(new Date(now.getFullYear(), now.getMonth(), 0));
			break;

		// ✅ THIS QUARTER (Financial Apr start → Today)
		case 'this_quarter': {
			const month = now.getMonth();
			let startMonth;

			if (month >= 3 && month <= 5) startMonth = 3;
			else if (month >= 6 && month <= 8) startMonth = 6;
			else if (month >= 9 && month <= 11) startMonth = 9;
			else startMonth = 0;

			from = formatStart(new Date(now.getFullYear(), startMonth, 1));
			to = new Date();
			break;
		}

		// ✅ PREVIOUS QUARTER
		case 'last_quarter': {
			const month = now.getMonth();
			let startMonth,
				year = now.getFullYear();

			if (month >= 3 && month <= 5) startMonth = 0;
			else if (month >= 6 && month <= 8) startMonth = 3;
			else if (month >= 9 && month <= 11) startMonth = 6;
			else {
				startMonth = 9;
				year = year - 1;
			}

			from = formatStart(new Date(year, startMonth, 1));
			to = formatEnd(new Date(year, startMonth + 3, 0));
			break;
		}

		// ✅ THIS YEAR
		case 'this_year':
			from = formatStart(new Date(now.getFullYear(), 0, 1));
			to = new Date();
			break;

		// ✅ PREVIOUS YEAR
		case 'last_year':
			from = formatStart(new Date(now.getFullYear() - 1, 0, 1));
			to = formatEnd(new Date(now.getFullYear() - 1, 11, 31));
			break;

		default:
			return { from: null, to: null };
	}
	return { from, to };
};

export function capitalizeWords(text) {
	return text
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
}

export function formatAMPMDate(dateString) {
	const date = new Date(dateString);

	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year = date.getFullYear();

	let hours = date.getHours();
	const minutes = String(date.getMinutes()).padStart(2, '0');

	const ampm = hours >= 12 ? 'PM' : 'AM';
	hours = hours % 12 || 12;

	return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
}

export function generateArray(limit) {
	return Array.from({ length: limit }, (_, i) => ({
		key: i,
		value: i,
	}));
}
export function generateExceptZeroArray(limit) {
	return Array.from({ length: limit }, (_, i) => ({
		key: i + 1,
		value: i + 1,
	}));
}
export const isNumber = (id) => {
	return typeof id === 'number' && !Number.isNaN(id);
};
